import { getActivePinia } from "pinia"

export default defineNuxtRouteMiddleware(to => {
    const pinia = getActivePinia()
    const store = useMainStore(pinia)
    if (!to.name) return // Ignore if no name
    const pageInfo = store.getPageInfo(to.name.toString())
    if (!pageInfo) return // Ignore if no pageInfo
    if ("redirectTo" in pageInfo && pageInfo.redirectTo) {
        return navigateTo(useLocaleValue(pageInfo, "redirectTo"), {
            external: true,
        })
    }
})
